import { legacy_createStore as createStore } from 'redux';
import { MessageStore, RemoveFirstFromTuple, StoreActionsLike } from './MessageList.store.types';
import { MessageListItem } from '../../types';
import { MessageListApi } from './MessageList.mutations';

function makeMessageStore<T extends StoreActionsLike>(apis: T): MessageStore<T> {
  const store = createStore<MessageListItem[], any>(
    (state?: MessageListItem[], action?: { type: keyof T; payload: RemoveFirstFromTuple<Parameters<T[keyof T]>> }) => {
      if (!state) return [];
      if (!action) return state;
      return apis[action.type](state, ...action.payload);
    }
  );

  const api = {
    get: store.getState,
    getAs: store.getState,
    subscribe: store.subscribe,
    ...Object.fromEntries(
      Object.keys(apis).map((type) => [type, (...payload: unknown[]) => store.dispatch({ type, payload })])
    ),
  } as MessageStore<T>;

  return api;
}

export const createMessageStore = () => makeMessageStore(MessageListApi);
export type MessageStoreApi = ReturnType<typeof createMessageStore>;
